<script setup lang="ts">
import logoImg from '@/assets/logo.png'

const SALES_PHONES = ['+8801716436241', '+8801951144403']
const AFTER_SALES = { wechat: 'tt_Guest_Service', phone: '+8613071187241' }
const EMAILS = [
  { label: 'After sales', address: 'servicereq@chinatourdeal.com' },
  { label: 'Package confirmation', address: 'sales@chinatourdeal.com' },
  { label: 'Refund', address: 'refund@chinatourdeal.com' },
  { label: 'Accounts', address: 'accounts@chinatourdeal.com' },
]
// const WHATSAPP_GROUP ='https://chat.whatsapp.com/J0Qcxot6defA2Vf145eh4K'

const OFFICES = [
  {
    name: 'China Operation Office',
    lines: ['Beijing TripTricks Travel Co. Ltd', 'Bldg 2, No.66 Yanfu Rd, Fangshan, Beijing 102400'],
  },
//   Global Sales Office:
// Trip Tricks, 2nd floor, Ka-24/4, Giyas Uddin Sarkar Market
// Bashundhara R/A Main Gate, Dhaka-1229, Bangladesh
  { name: 'Global Sales Office', lines: ['Trip Tricks, 2nd floor, Ka-24/4, Giyas Uddin Sarkar Market', 'Bashundhara R/A Main Gate, Dhaka-1229, Bangladesh'] },
]

// +8801716436241 → +880 1716 436241, +8613071187241 → +86 130 7118 7241: easier to read and to dial
const formatPhone = (phone: string) => phone
  .replace(/^(\+880)(\d{4})(\d+)$/, '$1 $2 $3')
  .replace(/^(\+86)(\d{3})(\d{4})(\d{4})$/, '$1 $2 $3 $4')

const year = new Date().getFullYear()
</script>

<template>
  <footer class="ft">
    <div class="ui-shell">
      <div class="ft-grid">
        <!-- Brand -->
        <div class="ft-brand">
          <RouterLink to="/home" class="ft-logo" aria-label="China Tour Deal, home">
            <img :src="logoImg" alt="China Tour Deal">
          </RouterLink>
          <p>Tour packages in China for travel agencies, at agency prices and under your own brand.</p>
          <!-- <a class="ft-whatsapp" :href="WHATSAPP_GROUP" target="_blank" rel="noopener noreferrer">
            <i class="fab fa-whatsapp" aria-hidden="true"></i>Join our WhatsApp group
          </a> -->
        </div>

        <!-- Offices -->
        <div class="ft-col">
          <h2>Our offices</h2>
          <ul class="ft-offices">
            <li v-for="office in OFFICES" :key="office.name">
              <i class="fa fa-map-marker-alt" aria-hidden="true"></i>
              <div>
                <strong>{{ office.name }}</strong>
                <span v-for="line in office.lines" :key="line">{{ line }}</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- Support -->
        <div class="ft-col">
          <h2>Support</h2>
          <h3>Sales inquiry</h3>
          <ul class="ft-contact">
            <li v-for="phone in SALES_PHONES" :key="phone">
              <a :href="`tel:${phone}`"><i class="fa fa-phone-alt" aria-hidden="true"></i>{{ formatPhone(phone) }}</a>
            </li>
          </ul>

          <h3>After-sales service</h3>
          <ul class="ft-contact">
            <li>
              <span><i class="fab fa-weixin" aria-hidden="true"></i>WeChat ID: {{ AFTER_SALES.wechat }}</span>
            </li>
            <li>
              <a :href="`tel:${AFTER_SALES.phone}`"><i class="fa fa-phone-alt" aria-hidden="true"></i>{{ formatPhone(AFTER_SALES.phone) }}</a>
            </li>
          </ul>

          <h3>Email</h3>
          <ul class="ft-contact ft-emails">
            <li v-for="email in EMAILS" :key="email.address">
              <small>{{ email.label }}</small>
              <a :href="`mailto:${email.address}`"><i class="fa fa-envelope" aria-hidden="true"></i>{{ email.address }}</a>
            </li>
          </ul>
        </div>

      </div>

      <div class="ft-bottom">
        <span>© {{ year }} China Tour Deal</span>
        <span>A concern of Trip Tricks</span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@import url("./AppFooter.css");
</style>
